module.exports = __webpack_public_path__ + "static/media/eclipTech_logo.21ebc845.svg";